import React, { ReactNode } from 'react';
import { Modal, ModalContent, ModalHeader, ModalHeadingText } from '../../../../wag-react/components/seo-models';
import { Divider } from '../../../../wag-react/core-components/divider';
export type WellnessPlansPageModalProps = {
  value: {
    name: ReactNode;
    description: string;
  };
  isOpen: boolean;
  onRequestClose: () => void;
};
export const WellnessPlansPageModal = ({
  isOpen,
  onRequestClose,
  value: {
    name,
    description
  }
}: WellnessPlansPageModalProps) => <Modal contentStyle={{
  maxWidth: '704px'
}} isOpen={isOpen} onRequestClose={onRequestClose} data-sentry-element="Modal" data-sentry-component="WellnessPlansPageModal" data-sentry-source-file="index.tsx">
    <ModalHeader px={['16px', '32px', null, null]} data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx">
      <ModalHeadingText maxWidth="80%" // Allow space for X icon
    data-sentry-element="ModalHeadingText" data-sentry-source-file="index.tsx">
        {name}
      </ModalHeadingText>

      <Divider border="1px solid #D1D1D1" my="4px" data-sentry-element="Divider" data-sentry-source-file="index.tsx" />
    </ModalHeader>

    <ModalContent px={['16px', '32px', null, null]} data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
      {description}
    </ModalContent>
  </Modal>;